/*
 * Time Tracking Page Messages
 *
 * This contains all the text for the Time Tracking Page.
 */

import { defineMessages } from 'react-intl';
export const scope = 'src.pages.TimeTrackingPage';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Time Tracking',
  },
  searchUidPlaceholder: {
    id: `${scope}.searchUidPlaceholder`,
    defaultMessage: 'UID',
  },
  searchPidPlaceholder: {
    id: `${scope}.searchPidPlaceholder`,
    defaultMessage: 'PID',
  },
  searchJidPlaceholder: {
    id: `${scope}.searchJidPlaceholder`,
    defaultMessage: 'JID',
  },
  projectColumnLabel: {
    id: `${scope}.projectColumnLabel`,
    defaultMessage: 'PID',
  },
  jobColumnLabel: {
    id: `${scope}.jobColumnLabel`,
    defaultMessage: 'JID',
  },
  studentColumnLabel: {
    id: `${scope}.studentColumnLabel`,
    defaultMessage: 'Student',
  },
  shiftColumnLabel: {
    id: `${scope}.shiftColumnLabel`,
    defaultMessage: 'Shift',
  },
  minimumHoursColumnLabel: {
    id: `${scope}.minimumHoursColumnLabel`,
    defaultMessage: 'Min. Hours',
  },
  contractColumnLabel: {
    id: `${scope}.contractColumnLabel`,
    defaultMessage: 'Contract',
  },
  briefingColumnLabel: {
    id: `${scope}.briefingColumnLabel`,
    defaultMessage: 'Briefing',
  },
  checkTypeColumnLabel: {
    id: `${scope}.checkTypeColumnLabel`,
    defaultMessage: 'Check Type',
  },
  checkinLabel: {
    id: `${scope}.checkinLabel`,
    defaultMessage: 'Check-In',
  },
  checkoutLabel: {
    id: `${scope}.checkoutLabel`,
    defaultMessage: 'Check-Out',
  },
  isCheckAsPlannedColumnLabel: {
    id: `${scope}.isCheckAsPlannedColumnLabel`,
    defaultMessage: 'As Planned?',
  },
  checkTimeSourceColumnLabel: {
    id: `${scope}.checkTimeSourceColumnLabel`,
    defaultMessage: 'Input Time',
  },
  defaultLabel: {
    id: `${scope}.defaultLabel`,
    defaultMessage: 'Default',
  },
  manualLabel: {
    id: `${scope}.manualLabel`,
    defaultMessage: 'Manual',
  },
  byUserLabel: {
    id: `${scope}.byUserLabel`,
    defaultMessage: '(user)',
  },
  byAdminLabel: {
    id: `${scope}.byAdminLabel`,
    defaultMessage: '(ucm)',
  },
  userCheckTimeColumnLabel: {
    id: `${scope}.userCheckTimeColumnLabel`,
    defaultMessage: 'User Input',
  },
  clientCheckTimeColumnLabel: {
    id: `${scope}.clientCheckTimeColumnLabel`,
    defaultMessage: 'Client Input',
  },
  plannedShiftColumnLabel: {
    id: `${scope}.plannedShiftColumnLabel`,
    defaultMessage: 'Planned Shift',
  },
  checkDeviationColumnLabel: {
    id: `${scope}.checkDeviationColumnLabel`,
    defaultMessage: 'Deviation',
  },
  isCheckAutoApprovedColumnLabel: {
    id: `${scope}.isCheckAutoApprovedColumnLabel`,
    defaultMessage: 'Auto Approved',
  },
  deviationReasonColumnLabel: {
    id: `${scope}.deviationReasonColumnLabel`,
    defaultMessage: 'Early/Late Reason',
  },
  noCodeReasonColumnLabel: {
    id: `${scope}.noCodeReasonColumnLabel`,
    defaultMessage: 'No Code Reason',
  },
  checkLocationColumnLabel: {
    id: `${scope}.checkLocationColumnLabel`,
    defaultMessage: 'Location',
  },
  checkInColumnLabel: {
    id: `${scope}.checkInColumnLabel`,
    defaultMessage: 'Check In',
  },
  checkOutColumnLabel: {
    id: `${scope}.checkOutColumnLabel`,
    defaultMessage: 'Check Out',
  },
  breakColumnLabel: {
    id: `${scope}.breakColumnLabel`,
    defaultMessage: 'Break',
  },
  breakTakenColumnLabel: {
    id: `${scope}.breakTakenColumnLabel`,
    defaultMessage: 'Break Taken',
  },
  breakPaidLabel: {
    id: `${scope}.breakPaidLabel`,
    defaultMessage: 'Paid',
  },
  breakUnpaidLabel: {
    id: `${scope}.breakUnpaidLabel`,
    defaultMessage: 'Unpaid',
  },
  userRatingColumnLabel: {
    id: `${scope}.userRatingColumnLabel`,
    defaultMessage: 'User Rating',
  },
  clientCommentColumnLabel: {
    id: `${scope}.clientCommentColumnLabel`,
    defaultMessage: 'Client Comment',
  },
  salaryColumnLabel: {
    id: `${scope}.salaryColumnLabel`,
    defaultMessage: 'Payment Summary',
  },
  adminCommentColumnLabel: {
    id: `${scope}.adminCommentColumnLabel`,
    defaultMessage: 'Admin Comment',
  },
  statusColumnLabel: {
    id: `${scope}.statusColumnLabel`,
    defaultMessage: 'Status',
  },
  billableColumnLabel: {
    id: `${scope}.billableColumnLabel`,
    defaultMessage: 'Billable',
  },
  nightColumnLabel: {
    id: `${scope}.nightColumnLabel`,
    defaultMessage: 'Night',
  },
  sundayColumnLabel: {
    id: `${scope}.sundayColumnLabel`,
    defaultMessage: 'Sunday',
  },
  holidayColumnLabel: {
    id: `${scope}.holidayColumnLabel`,
    defaultMessage: 'Holiday',
  },
  hoursColumnLabel: {
    id: `${scope}.hoursColumnLabel`,
    defaultMessage: 'Hours',
  },
  wageColumnLabel: {
    id: `${scope}.wageColumnLabel`,
    defaultMessage: 'Wage',
  },
  priceColumnLabel: {
    id: `${scope}.priceColumnLabel`,
    defaultMessage: 'Price',
  },
  bonusColumnLabel: {
    id: `${scope}.bonusColumnLabel`,
    defaultMessage: 'Bonus',
  },
  yesLabel: {
    id: `${scope}.yesLabel`,
    defaultMessage: 'Yes',
  },
  noLabel: {
    id: `${scope}.noLabel`,
    defaultMessage: 'No',
  },
  signedLabel: {
    id: `${scope}.signedLabel`,
    defaultMessage: 'Signed',
  },
  notSignedLabel: {
    id: `${scope}.notSignedLabel`,
    defaultMessage: 'Not Signed',
  },
  readLabel: {
    id: `${scope}.readLabel`,
    defaultMessage: 'Read',
  },
  notReadLabel: {
    id: `${scope}.notReadLabel`,
    defaultMessage: 'Not Read',
  },
  dateShifterHint: {
    id: `${scope}.dateShifterHint`,
    defaultMessage: 'Change the dates',
  },
  yesOptionLabel: {
    id: `${scope}.yesOptionLabel`,
    defaultMessage: 'Yes',
  },
  noOptionLabel: {
    id: `${scope}.noOptionLabel`,
    defaultMessage: 'No',
  },
  openInGoogleMapsHint: {
    id: `${scope}.openInGoogleMapsHint`,
    defaultMessage: 'Open in Maps',
  },
  hoursWarningLabel: {
    id: `${scope}.hoursWarningLabel`,
    defaultMessage: '> 12,5 hours',
  },
  cancelHint: {
    id: `${scope}.cancelHint`,
    defaultMessage: 'Cancel',
  },
  unCancelHint: {
    id: `${scope}.unCancelHint`,
    defaultMessage: 'Uncancel',
  },
  timeTrackingCancelled: {
    id: `${scope}.timeTrackingCancelled`,
    defaultMessage: 'Time tracking record cancelled successfully',
  },
  approveAndSubmitHint: {
    id: `${scope}.approveAndSubmitHint`,
    defaultMessage: 'Save & Approve',
  },
  submitHint: {
    id: `${scope}.submitHint`,
    defaultMessage: 'Submit',
  },
  timeTrackingApproved: {
    id: `${scope}.timeTrackingApproved`,
    defaultMessage: 'Time tracking record approved successfully',
  },
  approveTimeTrackingConfirmMessage: {
    id: `${scope}.approveTimeTrackingConfirmMessage`,
    defaultMessage:
      'Are you sure you want to approve this time tracking record?',
  },
  saveTimeTrackingConfirmMessage: {
    id: `${scope}.saveTimeTrackingConfirmMessage`,
    defaultMessage: 'Are you sure you want to save this time tracking record?',
  },
  timeTrackingSaved: {
    id: `${scope}.timeTrackingSaved`,
    defaultMessage: 'Time tracking record saved successfully',
  },
  timeTrackingsImportFailedPart1: {
    id: `${scope}.timeTrackingsImportFailedPart1`,
    defaultMessage: 'Some records failed importing',
  },
  timeTrackingsImportFailedPart2: {
    id: `${scope}.timeTrackingsImportFailedPart2`,
    defaultMessage: 'Please, check the downloaded file',
  },
  timeTrackingsImported: {
    id: `${scope}.timeTrackingsImported`,
    defaultMessage: 'Time Tracking records imported successfully',
  },
});
